import type { QueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { setLocale } from "@/i18n/actions";
import type { SessionUserSnapshot } from "@/lib/auth-server-fns";
import { patchViewerContextQueryData } from "@/lib/viewer-context";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

interface UsePersistAnonymousRouteLocaleOptions {
  queryClient: QueryClient;
  routeLocale: ViewerLocale | null;
  user: SessionUserSnapshot | null;
  viewerLocale: ViewerLocale;
}

export function usePersistAnonymousRouteLocale({
  queryClient,
  routeLocale,
  user,
  viewerLocale,
}: UsePersistAnonymousRouteLocaleOptions) {
  useEffect(() => {
    if (user || !routeLocale || routeLocale === viewerLocale) return;

    patchViewerContextQueryData(queryClient, {
      preferences: { locale: routeLocale },
    });

    void setLocale({ data: routeLocale }).catch(() => {
      patchViewerContextQueryData(queryClient, {
        preferences: { locale: viewerLocale },
      });
    });
  }, [queryClient, routeLocale, user, viewerLocale]);
}
